var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighFive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.2209 38.6055C80.422 36.0285 82.5769 34 85.2056 34C87.967 34 90.2056 36.2386 90.2056 39C90.2056 39.1304 90.2057 39.261 90.2059 39.3917C91.1043 38.5297 92.3238 38 93.6671 38C96.4286 38 98.6671 40.2386 98.6671 43C98.6671 50.6758 98.9398 58.3117 99.7419 65.6521C100.197 64.0759 100.657 62.5144 101.11 60.9753L101.37 60.0891C102.15 57.4399 104.929 55.924 107.578 56.7031C110.227 57.4823 111.743 60.2616 110.964 62.9108L110.804 63.4562C108.326 71.8794 105.932 80.017 104.915 87.5113C104.858 87.9318 104.806 88.3478 104.758 88.7592C107.557 96.4937 111.561 103.37 117.231 108.93C119.134 110.796 119.229 113.81 117.496 115.79C116.771 117.042 115.512 117.97 113.973 118.222C101.125 120.321 89.7938 115.414 83.7165 109.618C75.0436 101.348 69.7045 92.2244 67.0546 81.7329C64.4324 71.3511 64.5137 59.9065 66.2102 47.0631C66.5718 44.3254 69.0843 42.3993 71.8219 42.7609C72.1737 42.8074 72.512 42.8893 72.8338 43.0027V43C72.8338 40.2386 75.0724 38 77.8338 38C78.6983 38 79.5116 38.2194 80.2209 38.6055Z",
    fill: "#E580B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96 77.4999C96 77.4999 96 73.4999 99.5 64.9999",
    stroke: "#002E52",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3252 67.2502C81.3252 67.2502 80.7751 51.2798 80.0568 42.0496C79.8921 39.9343 80.5071 37.8254 81.8378 36.1728L81.9769 36",
    stroke: "#002E52",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.6934 38.1324C92.119 38.4844 92.1786 39.1147 91.8266 39.5403C90.8425 40.7301 90.3676 42.2665 90.4729 43.8294C90.7825 48.425 91.0251 54.8659 91.1902 60.1476C91.2728 62.7906 91.3362 65.1473 91.3789 66.8432C91.4002 67.6911 91.4164 68.374 91.4272 68.845L91.4436 69.5749C91.4436 69.575 91.4436 69.5757 90.4438 69.597C89.444 69.6182 89.444 69.6182 89.444 69.6181L89.4277 68.8911C89.4169 68.4213 89.4008 67.7399 89.3795 66.8935C89.3369 65.2006 89.2737 62.8481 89.1912 60.2101C89.0261 54.9297 88.7844 48.5203 88.4774 43.9639C88.3392 41.913 88.961 39.8667 90.2855 38.2655C90.6375 37.84 91.2679 37.7804 91.6934 38.1324ZM90.4651 70.5968C89.9129 70.6085 89.4558 70.1702 89.444 69.6181L90.4438 69.597L91.4436 69.5749C91.4553 70.1271 91.0172 70.585 90.4651 70.5968Z",
    fill: "#002E52"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4325 65.6156C73.4325 65.6156 72.9234 54.346 72.2076 46.1637C72.0102 43.9085 72.6557 41.6536 74.068 39.8844V39.8844",
    stroke: "#002E52",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.4461 36.6056C60.245 34.0285 58.0901 32 55.4614 32C52.7 32 50.4614 34.2386 50.4614 37C50.4614 37.1304 50.4613 37.261 50.4611 37.3917C49.5627 36.5297 48.3432 36 46.9999 36C44.2384 36 41.9999 38.2386 41.9999 41C41.9999 48.6758 41.7272 56.3117 40.9251 63.6521C40.4701 62.0759 40.0104 60.5144 39.5574 58.9753L39.2967 58.0891C38.5175 55.4399 35.7382 53.924 33.089 54.7031C30.4398 55.4823 28.9238 58.2616 29.703 60.9108L29.8634 61.4562C32.3414 69.8794 34.7353 78.017 35.7518 85.5113C35.8089 85.9318 35.8612 86.3478 35.9086 86.7592C33.1099 94.4937 29.106 101.37 23.436 106.93C21.5329 108.796 21.4376 111.81 23.1714 113.79C23.896 115.042 25.1551 115.97 26.6937 116.222C39.5424 118.321 50.8732 113.414 56.9505 107.618C65.6234 99.3478 70.9625 90.2244 73.6124 79.7329C76.2346 69.3511 76.1533 57.9065 74.4568 45.0631C74.0951 42.3254 71.5827 40.3993 68.8451 40.7609C68.4933 40.8074 68.155 40.8893 67.8332 41.0027V41C67.8332 38.2386 65.5946 36 62.8332 36C61.9687 36 61.1554 36.2194 60.4461 36.6056Z",
    fill: "#F0C1D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 77C39.5 77 40.5 71.5 40.5 63.5",
    stroke: "#002E52",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 66C57.5 66 58.6628 50.8842 58.9408 41.8097C59.0058 39.6889 59.8429 37.6571 61.3431 36.1569L61.5 36",
    stroke: "#002E52",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 66C49.5 66 50.7141 47.3839 50.9577 37.8227C51.0039 36.0123 51.7194 34.2806 53 33V33",
    stroke: "#002E52",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 66.5C65.5 66.5 66.2504 55.2439 66.4511 47.0328C66.5064 44.7697 67.3993 42.6007 69 41V41",
    stroke: "#002E52",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 112,
    y1: 29.5858,
    x2: 117.586,
    y2: 24,
    stroke: "#002E52",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 119.378,
    y1: 42.512,
    x2: 126.253,
    y2: 38.6221,
    stroke: "#002E52",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 8.8995,
    y2: -1,
    transform: "matrix(0.870356 0.492424 0.492424 -0.870356 117 72)",
    stroke: "#002E52",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 122.009,
    y1: 58.0088,
    x2: 129.908,
    y2: 58.0777,
    stroke: "#002E52",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 8.8995,
    y2: -1,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 25.8989 31)",
    stroke: "#002E52",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 8.8995,
    y2: -1,
    transform: "matrix(-0.870356 -0.492424 -0.492424 0.870356 18.8989 43.8748)",
    stroke: "#002E52",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 20.521,
    y1: 73.3628,
    x2: 13.6456,
    y2: 77.2527,
    stroke: "#002E52",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 8.8995,
    y2: -1,
    transform: "matrix(-0.999962 0.00872654 0.00872654 0.999962 16.8989 59)",
    stroke: "#002E52",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighFive);
export default __webpack_public_path__ + "static/media/high-five.e4a2c09d7ff5d2e924ce97618960a7cd.svg";
export { ForwardRef as ReactComponent };